export const BASE_PATH = '/reimbursements' as const

const REIMBURSEMENT_ACCOUNT_PATH = `${BASE_PATH}/accounts` as const
const REIMBURSEMENT_ACCOUNT_LINK_PATH = `${BASE_PATH}/accounts/link` as const

export const ReimbursementsPaths = {
  index: BASE_PATH,
  new_reimbursement: `${BASE_PATH}/create_new_reimbursement`,
  accounts: {
    index: REIMBURSEMENT_ACCOUNT_PATH,
    link: {
      index: REIMBURSEMENT_ACCOUNT_LINK_PATH,
      address: `${REIMBURSEMENT_ACCOUNT_LINK_PATH}/address`,
      account_number: `${REIMBURSEMENT_ACCOUNT_LINK_PATH}/account_number`,
      routing_number: `${REIMBURSEMENT_ACCOUNT_LINK_PATH}/routing_number`,
      bank: `${REIMBURSEMENT_ACCOUNT_LINK_PATH}/bank`,
      detail: `${REIMBURSEMENT_ACCOUNT_LINK_PATH}/detail`,
      nickname: `${REIMBURSEMENT_ACCOUNT_LINK_PATH}/nickname`,
      complete: `${REIMBURSEMENT_ACCOUNT_LINK_PATH}/complete`,
    },
  },
} as const

export type ReimbursementPathsType = typeof ReimbursementsPaths
